import React, { useCallback, useContext, useMemo, useState } from 'react';
import { Button, Modal, Input, Form, message, Select, Checkbox } from 'antd';
import { useQuery } from 'react-query';
import { EventContext } from 'modules/dashboard/pagesv2/event';
import { createGroup, getPhases } from 'api/events';

export const NewGroupModal = ({ isVisible, handleOk, refetch }) => {
  const { eventId, event } = useContext(EventContext);

  const [isPlayOff, setIsPlayOff] = useState(event.started);

  const fetchPhases = useCallback(async () => {
    const { body } = await getPhases();

    return body?.data?.tournament_phases || [];
  }, []);

  const { data } = useQuery('phases', fetchPhases);

  const phases = useMemo(() => {
    if (Array.isArray(data)) {
      return data.map(phase => {
        return {
          value: String(phase.id),
          label: phase.label,
        };
      });
    }
  }, [data]);

  const handleOnSubmit = async ({ play_off, tournament_phases_id, name }) => {
    const group = {
      play_off,
    };

    if (play_off) {
      group.tournament_phases_id = tournament_phases_id;
    } else {
      group.name = name;
    }
    try {
      await createGroup(eventId, group);
      message.success('!Grupo creado con éxito!');
      handleOk(false);
      refetch();
    } catch (error) {
      message.error('!Ha ocurrido un error!');
    }
  };

  const onPlayOffChange = e => {
    setIsPlayOff(!isPlayOff);
  };

  return (
    <Modal
      visible={isVisible}
      title={'Crear nuevo grupo'}
      onOk={() => handleOk(false)}
      onCancel={() => handleOk(false)}
      footer={[
        <Button key="back" onClick={() => handleOk(false)}>
          Cancelar
        </Button>,
        <Button form={'createGroup'} htmlType="submit" key="submit" type="primary">
          Crear
        </Button>,
      ]}
    >
      <Form id={'createGroup'} onFinish={values => handleOnSubmit(values)}>
        <Form.Item name="play_off" valuePropName="checked" initialValue={isPlayOff}>
          <Checkbox className="align-checkbox-clubes" onChange={e => onPlayOffChange(e)}>
            Fase eliminatoria
          </Checkbox>
        </Form.Item>
        {isPlayOff && (
          <Form.Item
            label="Fase"
            name="tournament_phases_id"
            rules={[
              {
                required: true,
                message: '!Ingresa una fase!',
              },
            ]}
          >
            <Select options={phases} />
          </Form.Item>
        )}
        {!isPlayOff && (
          <Form.Item
            label="Nombre del grupo"
            name="name"
            rules={[
              {
                required: true,
                message: '!Ingresa un nombre de grupo!',
              },
            ]}
          >
            <Input />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};
